const formatCharacteristic = (term: any) => {
  const formattedTerm = term.replace(/;/g, '.');
  return formattedTerm.split('\n');
};

export default formatCharacteristic;
